/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { demandSchema } from './demandSchema';

export const demandListSchema = z.object({
  get data() {
    return z.array(demandSchema);
  },
});
